import React, { useEffect, useState } from 'react';
import PrimaryButton from 'components/buttons/PrimaryButton';
import SecondaryButton from 'components/buttons/SecondaryButton';
import Checkbox from 'components/forms/basefields/Checkbox';
import { useModal } from 'components/modals/ModalContext';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from 'GlobalContext';

interface MandateModalProps {
    onConfirm: () => void;
}

const MandateModal: React.FC<MandateModalProps> = ({
    onConfirm
}) => {
    const { t } = useTranslation();
    const { revealModal, closeModal } = useModal();
    const { setFloatingAlert } = useGlobalContext();
    const [showWarning, setShowWarning] = useState(false);
    const [accepted, setAccepted] = useState(false);

    // Reveal the modal on render
    useEffect(() => {
        revealModal()
    }, []);

    return (
        <div className='mandate-modal'>
            <h6>
                {t("billing.general.first_payment_title")}
            </h6>
            <p>
                {t("billing.general.first_payment_description")}
            </p>
            <br />
            <h6>
                {t("billing.general.next_payments_title")}
            </h6>
            <p>
                {t("billing.general.next_payments_description")}
            </p>
            <br />
            <div className={showWarning ? 'warning' : ''}>
                <Checkbox
                    name="sepa_mandate_accepted"
                    label="billing.general.accept_mandate_label"
                    align='left'
                    value={accepted}
                    onChange={(e) => {
                        if (e.target.checked === true) {
                            setShowWarning(false);
                        }

                        setAccepted(e.target.checked); 
                    }}
                />
            </div>
            <br />
            <div className='buttons-right'>
                <SecondaryButton
                    label='general.cancel'
                    size="small"
                    onClick={closeModal}
                />
                <PrimaryButton
                    type="submit" 
                    label='billing.general.order_subscription_button'
                    size="small"
                    onClick={() => {
                        if (!accepted) {
                            setShowWarning(true);

                            setFloatingAlert({
                                type: "danger",
                                message: "billing.general.accept_mandate_required"
                            });
                            return;
                        }

                        closeModal();

                        onConfirm();
                    }}
                />
            </div>
        </div>
    );
}

export default MandateModal;